import axios from "axios";

export function index(id, forJob = true)
{
    let request = forJob
        ? axios.get(route('api.manage.jobs.stages', { jobId: id }))
        : axios.get(route('api.manage.companies.stages', { company: id }));

    return request.then(response => response.data);
}

export function updateSort(jobId, sort)
{
    return axios.patch(route('api.manage.jobs.stages.sort', { jobId: jobId}), {
        data: sort
    }).then(response => {
        return response.data;
    });
}

export function store(jobId, data)
{
    return axios.post(route('api.manage.jobs.stages', { jobId: jobId}), data)
        .then(response => response.data);
}

export function update(stageId, data)
{
    return axios.patch(route('api.manage.stages.update', { stageId: stageId }), data)
        .then(response => response.data);
}

export function destroy(stageId)
{
    return axios.delete(route('api.manage.stages.destroy', { stageId: stageId }));
}
